<script>
/*
  Vision Venture — Sticky Header
  - Same API as StandardV2Header (title, showBack, compactBack, actions, @action)
  - Config มาจาก route.meta.visionVentureHeader (อ่านโดย VisionVentureLayout)
  - พื้นขาวล้วน + shadow นุ่ม; back / action ใช้ primary-color
*/

export default {
  name: "VvHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: false
    },
    compactBack: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: "default"
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    emitAction(action) {
      this.$emit("action", action);
    }
  }
};
</script>

<template>
  <button
    v-if="compactBack"
    type="button"
    class="vv-header__compact-back"
    data-test="vv-header-compact-back-btn"
    @click="$router.back()"
  >
    <font-awesome-icon :icon="['fas', 'chevron-left']" />
  </button>
  <header
    v-else
    :class="['vv-header', `vv-header--${variant}`]"
    data-test="vv-header"
  >
    <button
      v-if="showBack"
      type="button"
      class="vv-header__back"
      data-test="vv-header-back-btn"
      @click="emitAction({ key: 'back' })"
    >
      <font-awesome-icon :icon="['fas', 'chevron-left']" />
    </button>
    <div v-else class="vv-header__spacer"></div>

    <div class="vv-header__title" data-test="vv-header-title">
      {{ title }}
    </div>

    <div
      id="vv-header-extra"
      class="vv-header__extra"
      data-test="vv-header-extra"
    ></div>

    <div class="vv-header__actions">
      <button
        v-for="action in actions"
        :key="action.key"
        type="button"
        class="vv-header__action"
        :data-test="`vv-header-${action.key}-btn`"
        @click="emitAction(action)"
      >
        <font-awesome-icon :icon="action.icon" />
      </button>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.vv-header {
  position: sticky;
  top: 0;
  z-index: 15;
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr) auto auto;
  min-height: 50px;
  align-items: center;
  gap: 8px;
  padding: 16px 12px;
  border-radius: 0 0 24px 24px;
  background: var(--bar-color);
  box-shadow: var(--crm-vv-header-shadow);
  font-size: var(--font-title-sm);
}

.vv-header__back,
.vv-header__action {
  display: inline-flex;
  width: 34px;
  height: auto;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: var(--primary-color);
  cursor: pointer;
}
.vv-header__compact-back {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.322);
  color: var(--primary-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.vv-header__spacer {
  width: 34px;
  height: auto;
}

.vv-header__title {
  overflow: hidden;
  margin: 0;
  color: var(--tab-text-color);
  font-family: var(--crm-vv-title-font-family);
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vv-header__extra {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;

  &:empty {
    display: none;
  }
}

.vv-header__actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.vv-header--register-flow {
  grid-template-columns: 42px minmax(0, 1fr) 42px;
  min-height: 70px;
  padding: 20px 16px 10px;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  font-size: var(--font-title);

  .vv-header__back {
    width: 34px;
    height: 34px;
    border-radius: 999px;
    background: var(--crm-vv-register-surface);
    box-shadow: var(--crm-vv-register-action-shadow);
    color: var(--primary-color);
  }

  .vv-header__title {
    text-align: center;
  }
}

.vv-header--eye-record {
  font-size: var(--font-body-lg);

  .vv-header__title {
    color: var(--text-color);
  }
}
</style>
